<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Doc — Publicações: Listagem e exibição
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Como
        strong  listar
        |  e
        strong  abrir
        |  publicações de documentos.

      .toast.toast-primary
        | Exige
        strong  Publicações → Publicações de documentos → Listar
        |  /
        strong  Exibir
        | .

      h5.h5 1. Abrir Publicações
      ol
        li Em
          strong  Doc
          | , clique em
          strong  Publicações
          | .
      figure.manual-figure
        img(:src="imgLista" alt="Listagem de Publicações")
      p Cada publicação aparece com descrição, número/ano, data e situação
        |  (Aberto, Encerrado, Cancelado).

      h5.h5 2. Abrir a publicação
      ol
        li Clique em
          strong  Exibir
          |  no registro desejado.
      figure.manual-figure
        img(:src="imgShow" alt="Exibição de uma Publicação")
      p A tela mostra dados da publicação, documentos vinculados e ações do rodapé
        |  (ver manuais de Nova/editar e Ações).
      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/19-doc-publicacoes-lista.png"),
      imgShow: require("@/assets/manuais/19b-doc-publicacoes-show.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
